import React from 'react';
// import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const ConvertPartyTicketModal = ({ closeModal }) => {
  return (
    <div className="modal-party-ticket modal-dialog">
      <div className="modal-content">
        <div className="modal-body">
          <div className="modal-party-ticket-grid">
            <div className="modal-party-ticket-grid-part--title">
              <div className="modal-party-ticket-title">
                CONVERT <br className="break-desktop" />
                PARTY <strong>ONLINE</strong>
              </div>
              <div className="modal-party-ticket-subtitle">
                Не пропустите самый большой розыгрыш призов в прямом эфире от OFFERRUM!
              </div>
            </div>

            <div className="modal-party-ticket-grid-part--second">
              <div className="modal-party-ticket-time-location">
                <span className="modal-party-ticket-time">5 июня, начало в 18:00</span>
              </div>
              <div className="modal-party-ticket-disclaimer">
                Запустите телеграм-бота
                <br />
                CONVERT PARTY, чтобы получить напоминание о розыгрыше призов!
              </div>
              <a
                className="btn btn-primary modal-party-ticket-button"
                href="https://t.me/convertpartybot"
                target="_blank"
                rel="noopener"
              >
                Запустить бота
              </a>
            </div>
          </div>
          <div className="modal-party-ticket-alert">
            В связи с эпидемологической ситуацией в Санкт-Петербурге, Convert Party изменен и будет
            проводиться БЕСПЛАТНО и ОНЛАЙН!
          </div>
          <button className="modal-party-ticket-close" onClick={closeModal}>
            <img src={`${STATIC_PATH}/img/party-ticket-modal/party-ticket-close.svg`} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConvertPartyTicketModal;
